import type { SVGProps } from "react";
export interface Collapse04IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Collapse04Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Collapse04IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.876 20v-4c0-.62.503-1.125 1.124-1.125h4l.115.006a1.125 1.125 0 0 1 0 2.239l-.115.005h-1.284l3.08 3.08.077.085a1.125 1.125 0 0 1-1.583 1.583l-.085-.078-3.08-3.079V20a1.125 1.125 0 0 1-2.25 0ZM2.205 2.204a1.125 1.125 0 0 1 1.506-.078l.084.078 3.08 3.079V4a1.125 1.125 0 0 1 2.25 0v4c0 .62-.504 1.124-1.125 1.124H4a1.125 1.125 0 0 1 0-2.25h1.284l-3.08-3.079-.077-.085a1.125 1.125 0 0 1 .078-1.505Zm18 .001a1.125 1.125 0 1 1 1.59 1.59l-3.079 3.08H20l.115.005a1.125 1.125 0 0 1 0 2.239L20 9.124h-4A1.125 1.125 0 0 1 14.876 8V4a1.125 1.125 0 0 1 2.25 0v1.284l3.079-3.08ZM9.125 19.999a1.125 1.125 0 1 1-2.25 0v-1.283l-3.08 3.08a1.125 1.125 0 1 1-1.59-1.591l3.079-3.08H4a1.125 1.125 0 0 1 0-2.25h4c.62 0 1.125.504 1.125 1.125v4Z"
      />
    </svg>
  );
}
